export const numberOfColumns = 12;
export const rowHeight = 80;
export const maxWidgets = 15;
